// @flow
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import appState from './modules/reducers';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { LicenseManager } from 'ag-grid-enterprise/main';
import App from './containers/AppContainer';

import 'ag-grid-root/dist/styles/ag-grid.css';
import 'ag-grid-root/dist/styles/theme-fresh.css';
import 'ag-grid-root/dist/styles/theme-bootstrap.css';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

LicenseManager.setLicenseKey(
    'SBI_Software_MultiApp_4Devs3_SaaS_14_December_2018__MTU0NDc0NTYwMDAwMA==112e82c1bad86313f72001785aee5109'
);
const store = createStore(
    appState,
    compose(
        applyMiddleware(thunk),
        window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : x => x
    )
);

function Analytics() {
    return (
        <Provider store={store}>
            <App />
        </Provider>
    );
}

const renderTarget = document.getElementById('pages');
if (renderTarget) {
    render(<Analytics />, renderTarget);
}



// WEBPACK FOOTER //
// ./index.jsx